import emptyFunction from "@jnctn/core/utilities/emptyFunction";
import Notice from "@jnctn-app/core/notices/Notice";
import { ComponentProps, createContext } from "react";
import { HubConnection } from "@microsoft/signalr";

const NoticesContext = createContext<{
  update: boolean;
  install: boolean;
  installable: boolean;
  registration: ServiceWorkerRegistration | undefined;
  signalR: HubConnection | undefined;
  showDevTools: boolean;
  transientNotices: Map<string, [number, ComponentProps<typeof Notice>]>;

  setUpdate: (value: boolean) => void;
  setInstall: (value: boolean) => void;
  setInstallable: (value: boolean) => void;
  setShowDevTools: (value: boolean) => void;
  addToHomeScreen: () => void;
  addTransientNotice: (
    key: string,
    notice: ComponentProps<typeof Notice>,
    delay?: number
  ) => void;
  removeTransientNotice: (key: string) => void;
}>({
  update: false,
  install: false,
  installable: false,
  registration: undefined,
  signalR: undefined,
  showDevTools: false,
  transientNotices: new Map(),

  setUpdate: emptyFunction,
  setInstall: emptyFunction,
  setInstallable: emptyFunction,
  setShowDevTools: emptyFunction,
  addToHomeScreen: emptyFunction,
  addTransientNotice: emptyFunction,
  removeTransientNotice: emptyFunction,
});

export default NoticesContext;
